import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Resource, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  disableResource(request: Boundaries["disableResource"]["request"]): void;
}

function useDisableResource(resource: Identifiable<Resource>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isDisableResourceRequestPending(resource),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isDisableResourceRequestSuccess(resource),
    ),
    isRequestFailure: useSelector(() =>
      selector.isDisableResourceRequestFailure(resource),
    ),
    disableResource: core.disableResource,
  };
}

export { useDisableResource };
